/* crux data calculations */
import Snap from 'snapsvg';

function CruxMeters(){

  //count percentage. If need to chage something with the values, do it here
  const countPercentage = (data) => {
    if (data === undefined) return 0;

    const percentage = data.histogram[0].density * 100;

    return percentage.toFixed();

  };

  //get data for speedometer, value and title
  const getSpeedoMeterData = (metrics) => {
    return {
      cls: {
        percentage: countPercentage(metrics.cumulative_layout_shift),
        title: 'Cumulative Layout Shift'
      },
      ettfb: {
        percentage: countPercentage(metrics.experimental_time_to_first_byte),
        title: 'Experimental Time To First Byte'
      },
      fcp: {
        percentage: countPercentage(metrics.first_contentful_paint),
        title: 'First Contentful Paint'
      },
      fid: {
        percentage: countPercentage(metrics.first_input_delay),
        title: 'First Input Delay'
      },
      itnp: {
        percentage: countPercentage(metrics.interaction_to_next_paint),
        title: 'Interaction To Next Paint'
      },
      lcp: {
        percentage: countPercentage(metrics.largest_contentful_paint),
        title: 'Largest Contentful Paint'
      }
    }
  };


  const polar_to_cartesian = (cx, cy, radius, angle) => {
    let radians;
    radians = (angle - 90) * Math.PI / 180.0;
    return [Math.round((cx + (radius * Math.cos(radians))) * 100) / 100, Math.round((cy + (radius * Math.sin(radians))) * 100) / 100];
  }

  const svgPath = (x, y, radius, start_angle, end_angle) => {
    let end_xy, start_xy;
    start_xy = polar_to_cartesian(x, y, radius, end_angle);
    end_xy = polar_to_cartesian(x, y, radius, start_angle);
    return 'M ' + start_xy[0] + ' ' + start_xy[1] + ' A ' + radius + ' ' + radius + ' 0 0 0 ' + end_xy[0] + ' ' + end_xy[1];
  }

  const animate_arc = (ratio, svg) => {
    //set as close as 100 to avoid eternal loop in animation
    ratio = (ratio === '100') ? '.99999999' : ratio;

    let arc = svg.path('');
    const current = svg;
    return Snap.animate(0, ratio, (function(val) {

      var path;
      arc.remove();
      path = svgPath(500, 500, 450, -90, val * 180.0 - 90);
      arc = svg.path(path);
      arc.attr({
        class: 'data-arc'
      });
    }), Math.round(500 * ratio), function() {
      // stop animation
      current.stop();
    });

  }

  //draw speedometer
  const drawCruxSpeedometer = (value) => {

    const ratio = (value.percentage < 100) ? '.'+value.percentage : value.percentage;

    //these values are just from my head, if you want to change something, do it here
    let color = 'green'
    color = (value.percentage < 80) ? 'yellow' : color;
    color = (value.percentage < 50) ? 'red' : color;

    return `
        <div class="metric participation ${color}" data-ratio="${ratio}">
          <svg viewBox="0 0 1000 500">
            <path d="M 950 500 A 450 450 0 0 0 50 500"></path>
            <text class='percentage' text-anchor="middle" alignment-baseline="middle" x="500" y="350" font-size="140" font-weight="bold">${value.percentage}%</text>
          </svg>
          <p>${value.title}</p>
        </div> `;
  }

  //draw svg container and speedometers
  const drawSvgContainer = (value) => {
    let htmlToReturn = '<div class="crux-speedometer"><div class="grid">';
    for (const [key, value] of Object.entries(value)) {
      htmlToReturn += drawCruxSpeedometer(value);
    }
    htmlToReturn += '</div></div>';
    return htmlToReturn;
  }


  //set animation for each speedometer
  const intializeSpeedometers = () => {

    const speedometers = document.querySelectorAll('.crux-speedometer svg');
    speedometers.forEach(speedometer => {
      const ratio = speedometer.parentElement.dataset.ratio;
      const svg = Snap(speedometer);
      animate_arc(ratio, svg);

    });

  }

  //init function
  const init = (cruxData, container) => {
    const speedoData = getSpeedoMeterData(cruxData);

    container.innerHTML = drawSvgContainer(speedoData);

    intializeSpeedometers();
  }

  //return public functions
  return {
    init: init,
  }
}

export default CruxMeters;

